import { render, staticRenderFns } from "./YessProfilesListItem.vue?vue&type=template&id=0c22e670&scoped=true"
import script from "./YessProfilesListItem.vue?vue&type=script&lang=js"
export * from "./YessProfilesListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c22e670",
  null
  
)

export default component.exports